let _shopify_locale = Shopify.locale;
let _shopify_country = Shopify.country;
let _affirm_locale;
let _affirm_country;
let _region_public_key;

if (_shopify_country === 'US') {
    _affirm_country = 'USA';
    _affirm_locale = 'en_US';
    _region_public_key = '80D531274Z8QAVCG'
} else if (_shopify_country === 'CA') {
    _affirm_country = 'CAN';
    _affirm_locale = (_shopify_locale === 'fr' ?  'fr' : 'en') + '_' + _shopify_country;
    _region_public_key = '80D531274Z8QAVCG'
} else {
    _affirm_country = 'USA';
    _affirm_locale = 'en_US'
    _region_public_key = '80D531274Z8QAVCG'
}

_affirm_config = {
   public_api_key: _region_public_key,
   script:          "https://cdn1.affirm.com/js/v2/affirm.js",
   locale: _affirm_locale,
   country_code: _affirm_country,
};

(function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
